
    import React, {Fragment} from 'react';
    import ReactDOM from 'react-dom';
    import LottieComponent from "./LottieComponent";
    import Lottie from "react-lottie";
  /*  import * as animationData from "./LottieData/Mobile_Animazione_feste_2.json";*/
    import * as animationData from "./LottieData/7PURINA_PetPassion_Desktop_primavera.json";
    const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17";




    export default class RicorsivaPage extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                logged: false,
                img:'',
                isStopped: true,
                isPaused: false,
                stepView:0,
            }

            this.customCall = this.customCall.bind(this);

        }

        componentDidMount() {

            const logged = document.getElementById("ricorsiva").getAttribute("logged") === "true" ? true : false;
            //const logged = true;
            this.setState({ logged:logged });
        }

        customCall(){
            this.setState(
                { isStopped: true , stepView:1 }
                )
        }

        render() {


            const defaultOptions = {
                loop: false,
                autoplay: false,
                animationData: animationData,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                },
            };

            return (
                <Fragment>
                    <div className={'row'}>
                        <div className={'container-fluid'}>
                            <img style={{width: '100%'}} src="/global17/img/ricorsiva/wave7primavera.png"></img>
                        </div> 
                    </div>
                    { !this.state.logged &&   this.state.stepView == 0  && (
                            <div className={'row'} style={{height: '280px'}}>
                                <div id={'r-bg-'} className={'container-fluid'}>
                                    <div className={'r-content-text'}  >
                                        <p className={'r-text-content'}>È il tuo giorno fortunato 😊
                                            Per svelare il regalo di oggi accedi alla community:
                                        </p>
                                    </div>
                                    <div style={{display: 'flex', 'justifyContent': 'center'}}>

                                        <div id={'section-btn-log-register'}>
                                            <button className={'r-btn-login'}
                                                    onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`}>
                                                login
                                            </button>
                                        </div>
                                        <div id={'section-btn-log-register'}>
                                            <button className={'r-btn-iscriviti'}>Iscriviti</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    { this.state.logged  && this.state.stepView == 0 && (
                        <div className={'row'} id={'margin-50-row-top-bottom'} >
                            <div id={'r-bg-'} className={'container-fluid'}>
                                <div id={'animation-wrap-lotties'}>
                                    <Lottie options={defaultOptions}

                                            width={'100%'}
                                            eventListeners={
                                                [{
                                                    eventName: 'complete',
                                                    callback:  this.customCall ,
                                                }]
                                            }
                                            isStopped={this.state.isStopped}
                                            isPaused={this.state.isPaused} />
                                </div>


                                    <button style={{ width:'100%', maxWidth:'400px' }} className={"play-button-ricorsiva"} onClick={() => this.setState({isStopped: false})}>
                                        Clicca per scoprire il regalo
                                    </button>
                            </div>
                        </div>  )
                    }
                    { this.state.logged && this.state.stepView == 1 && (

                        <div className={'row'} id={'margin-50-row-top-bottom'}>
                            <div id={'r-bg-'} className={'container'}>
                                <div className={'popup-pdf'}  >
                                    <div className={'item'} style={{ flex:1 }}>
                                        <img id={'img-cat-desktop-ric'} className={'imgdogcat'}  src={'/global17/bundles/games/src/images/dog-ricorsiva.png'} />
                                    </div>
                                    <div className={'item'} style={{ flex:3 }}>
                                        <p className={'title-dog-cat'}>
                                            GRAZIE PER ESSERE UN MEMBRO DELLA COMMUNITY DI CHI AMA GLI ANIMALI!
                                        </p>
                                        <p className={'descript'}>
                                        GRAZIE PER ESSERE UN MEMBRO DELLA COMMUNITY DI CHI AMA GLI ANIMALI!
                                        Scopri il regalo digitale che ti abbiamo riservato cliccando su uno dei due bottoni qui sotto,
                                         il tuo amico a quattro zampe del cuore è un cane o un gatto?
                                         </p>
                                        <div style={{display: 'flex', 'justifyContent': 'center'}} >
                                            <div style={{ flex:1 ,textAlign:'center'}}>
                                                <img id={'img-dog-mobile-ric'} className={'imgdogcat'}  src={'/global17/bundles/games/src/images/dog-ricorsiva.png'} />
                                                <a href={'/global17/bundles/games/src/images/cane_W8.png'}  download className={'play-button-ricorsiva-red'}>CANE</a>
                                            </div>
                                            <div style={{ flex:1 ,textAlign:'center'}}>
                                                <img id={'img-cat-mobile-ric'} className={'imgdogcat'} src={'/global17/bundles/games/src/images/cat-ricorsiva.png' } />
                                                <a href={'/global17/bundles/games/src/images/gatto_W8.png'}  download   className={'play-button-ricorsiva-red'}>GATTO</a>
                                            </div>
                                        </div>
                                        <p>
                                        Puoi tornare su questa pagina e scaricare i regali quante volte vuoi, fino al 19/03.
                                        
                                        </p>
                                    </div>
                                    <div className={'item'} style={{ flex:1 }}>
                                        <img id={'img-dog-desktop-ric'} className={'imgdogcat'} src={'/global17/bundles/games/src/images/cat-ricorsiva.png' } />
                                    </div>

                                </div>



                            </div>
                        </div>
                    )
                }

                </Fragment>
            );
        }

    }


    document.addEventListener("DOMContentLoaded", () => {
        const mountPoint = document.getElementById("ricorsiva");
        if(mountPoint)
            ReactDOM.render(<RicorsivaPage />, mountPoint);
    });
